@if (dialog.recurso(); as recurso) {
  <div
    class="fixed inset-0 bg-ink/40 z-50 flex items-center justify-center p-4"
    data-overlay="true"
    (click)="onOverlayClick($event)"
  >
    <div class="bg-white rounded-lg border border-border shadow-lg w-full max-w-[420px]" role="dialog" aria-modal="true">

      <div class="flex items-start justify-between p-5 pb-0">
        <div class="min-w-0">
          <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-[0.06em] bg-[#FBF1D7] text-[#8B5E00]">
            {{ 'layout.comingSoon' | translate }}
          </span>
          <h2 class="text-[17px] font-semibold text-ink leading-[1.3] mt-2">{{ recurso }}</h2>
        </div>
        <button
          type="button"
          (click)="close()"
          class="w-7 h-7 -mt-1 flex items-center justify-center rounded-md text-muted hover:text-ink hover:bg-surface transition-colors duration-[160ms] shrink-0 ml-2"
          [attr.aria-label]="'common.close' | translate"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      @if (enviado()) {
        <div class="px-5 py-5 flex flex-col gap-3">
          <div class="flex items-center gap-2.5">
            <span class="w-8 h-8 rounded-full bg-[#E5F6EE] flex items-center justify-center shrink-0">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="text-success">
                <path d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <p class="text-sm text-ink leading-[1.5]">{{ 'interesse.sucesso' | translate }}</p>
          </div>
          <button
            type="button"
            (click)="close()"
            class="w-full h-10 rounded-[10px] border border-border bg-white hover:bg-surface text-ink font-semibold text-sm transition-colors duration-[160ms]"
          >
            {{ 'common.close' | translate }}
          </button>
        </div>

      } @else {
        <div class="px-5 py-4 flex flex-col gap-3">
          <p class="text-sm text-muted leading-[1.6]">{{ 'interesse.desc' | translate }}</p>

          <div class="flex flex-col gap-1.5">
            <label for="interesse-msg" class="text-[13px] font-semibold text-ink leading-[1.4]">
              {{ 'interesse.label' | translate }}
            </label>
            <textarea
              id="interesse-msg"
              [(ngModel)]="mensagem"
              rows="3"
              [placeholder]="'interesse.placeholder' | translate"
              class="w-full rounded-md border border-border px-3 py-2 text-[14px] text-ink leading-[1.5] resize-none focus:outline-none focus:border-primary-500 focus:ring-[3px] focus:ring-primary-500/20 transition-colors duration-[160ms]"
            ></textarea>
          </div>

          @if (erro(); as msg) {
            <p class="text-[13px] text-danger leading-[1.5]">{{ msg }}</p>
          }
        </div>

        <div class="px-5 pb-5">
          <button
            type="button"
            (click)="enviar()"
            [disabled]="enviando()"
            [class]="'w-full h-11 rounded-[10px] text-white font-semibold text-sm transition-colors duration-[160ms] flex items-center justify-center gap-2 ' + (enviando() ? 'bg-primary-500 opacity-60 cursor-not-allowed' : 'bg-primary-500 hover:bg-primary-600 active:bg-primary-700')"
          >
            @if (enviando()) {
              <app-loader inline size="sm" [label]="'interesse.enviando' | translate" />
            } @else {
              {{ 'interesse.cta' | translate }}
            }
          </button>
        </div>
      }

    </div>
  </div>
}
